import "./HowWeWork.module.css";
import MainNavigation from "@/reusable_sections/Header";
import OurProcess from "./sections/OurProcess";
import CollaborationModel from "./sections/CollaborationModel";
import ToolsMethodologies from "./sections/ToolsMethodologies";
import Footer from "@/reusable_sections/Footer";
export default function HowWeWorkPage() {
  return <div>
      <MainNavigation />
      <OurProcess />
      <CollaborationModel />
      <ToolsMethodologies />
      <Footer />
    </div>;
}